import axios from "axios";
import Vue from "vue";
import VueRouter from "./../routes.js";
import log from "./log.js";

import { USER_LOGOUT } from "./../store/modules/users";

function errorNotify(title, text = "", duration = 10000) {
  Vue.notify({
    group: "app",
    type: "error",
    title: title,
    text: text,
    duration
  });
}

let serialize = function(obj, prefix) {
  let str = [],
    p;

  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];

      if (v !== null && typeof v === "object") {
        str.push(serialize(v, k));
      } else {
        if (v !== null) {
          str.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
      }
    }
  }

  return str.join("&");
};

const http = {
  token: null,
  store: null,

  setStore(store) {
    this.store = store;
  },
  setToken(token) {
    this.token = token;
  },

  /**
   * Проверяет, нужно ли выполнять логаут при получении ошибки 401
   * @param {string} url - URL запроса
   * @param {string} prefix - Префикс, который должен присутствовать в URL
   * @returns {boolean} - true если нужно выполнять логаут, иначе false
   */
  checkPathInUrl(url, prefix = '/gateway/') {
    return url && url.includes(prefix);
  },

  /**
   * Выполняет HTTP запрос
   * @param {string} method - Метод запроса (get, post, put, patch, delete)
   * @param {string} url - URL запроса
   * @param {Object} params - Параметры запроса
   * @param {Object} options - Опции запроса
   * @param {boolean} options.throwOnError - Флаг, определяющий, нужно ли пробрасывать ошибку или возвращать результат
   * @returns {Promise} Promise с результатом или ошибкой
   */
  request(method, url, params, options) {
    let config = {
      method: method,
      ...options
    };

    if (method == "get") {
      url = url + "?" + serialize(params);
    }

    if (method != "get") {
      config.data = params;
    }

    config.url = url;

    // Создаем объект заголовков с учетом дополнительных заголовков из options
    config.headers = {
      ...(options?.headers || {})
    };

    // Добавляем токен авторизации, если он доступен
    if (this.token) {
      config.headers.Authorization = "bearer " + this.token;
    }

    let request = axios(config).catch(error => {
    const throwOnError = options?.throwOnError || false;

      if (error.response && error.response.status == 401) {
        if (!this.checkPathInUrl(url, '/gateway/')) {
          this.store.dispatch(USER_LOGOUT);
        }

        if (throwOnError) {
          throw error.response.data;
        }
        return false;
      }

      if (error.response && error.response.status == 403) {
        const tmpLang = this.store.getters.lang;
        const localGetTranslate = require(`./../langs/http/${tmpLang}.json`);
        const msg = error.response.data?.errors?.error || error.response.data?.message || null;

        if (!throwOnError) {
        errorNotify(localGetTranslate.access_error, msg || localGetTranslate.no_access_please);
        }

        if (throwOnError) {
          throw error.response.data;
        }
        return;
      }

      if (error.response && error.response.status == 404) {
        log.notFound(error.response)
        let match = VueRouter.app.$route.path
        if (error.response.config.url[error.response.config.url.length - 1] == '?') {
            match += '?'
        }
        let currPath = error.response.config.url.substring(error.response.config.url.length - match.length)
        if(match == currPath) {
            VueRouter.push('/404')
        }
      }

      if (error.response && error.response.status == 409) {
        const tmpLang = this.store.state.users.auth_user.lang;
        const localGetTranslate = require(`./../langs/http/${tmpLang}.json`);

        if (!throwOnError) {
        errorNotify(localGetTranslate.conflict_error, error.response.data.message);
        }

        if (throwOnError) {
          throw error.response.data;
        }
        return;
      }

      if (error.response && error.response.data) {
        throw error.response.data;
      } else {
        throw error;
      }
    });
    return request;
  },

  get(url, params, options) {
    return this.request("get", url, params, options);
  },
  post(url, params, options) {
    return this.request("post", url, params, options);
  },
  put(url, params, options) {
    return this.request("put", url, params, options);
  },
  patch(url, params, options) {
    return this.request("patch", url, params, options);
  },
  delete(url, params, options) {
    return this.request("delete", url, params, options);
  },
  cancel() {
    let cancelToken = axios.CancelToken;
    let source = cancelToken.source();

    return source;
  },
  all(promises) {
    let promise = axios.all(promises).then(
      axios.spread(function(acct, perms) {
        return true;
      })
    );

    return promise;
  },
  /**
   * Получение текущего выбранного языка системы (метод сделан для api.js)
   * @return {string} текущий выбранный язык системы
   * @author SeregaHelf
   */
  getLang() {
    return this.store.getters.lang;
  },
};

export default http;
